import * as d3 from 'd3-selection'
import { interpolate } from 'd3-interpolate'

const dimensions = {
  labelDistance: 25,
  axisLineExtend: 5,
  xAxisTitleHeight: 18 // TODO Copied in cartesian.js
}

class PolarLayout {

  constructor (options) {
    this.previousScaler = options.previousScaler
    this.scaler = options.scalers.x.groupScale

    this.width = options.scalers.x.plotScale.bandwidth()
    this.radius = options.scalers.y.left.range()[1]
  }

  axisTransform (selection, height) {
    let x = this.width / 2
      , y = height / 2

    selection.attr('transform', `rotate(-90 ${x} ${y}) translate(${x}, ${y})`)
  }

  /*
   * Entering nodes will start at the top
   */
  enterTransform (selection) {
    let domain0 = this.previousScaler.domain()
      , domain1 = this.scaler.domain()
      , prevStartIdx = domain1.indexOf(domain0[0])
      , prevEndIdx = domain1.indexOf(domain0[domain0.length - 1])
      , groupScale = this.previousScaler
      , angle = 0
      , radius = this.radius

    selection.attr('transform', function (d, i) {
                let idx = domain1.indexOf(d.id)
                  , dx = groupScale.bandwidth() / 2
                  , x = groupScale(d.id)

                if (idx < prevStartIdx) {
                  angle = (groupScale(domain0[domain0.length - 1]) * 180 / Math.PI) - 360
                } else if (prevEndIdx != -1 && idx > prevEndIdx) {
                  // Start at the previous first element (probably at 0)
                  angle = 360 - (groupScale(domain0[0]) * 180 / Math.PI)
                }
                this._angle = angle
                return `rotate(${angle})`
              })
              .selectAll('.text-group')
              .attr('transform', function () {
                return `rotate(${-angle + 90} ${radius + dimensions.labelDistance}, 0) translate(${radius + dimensions.labelDistance}, 0)`
              })

    selection.selectAll('line')
             .attr('x2', this.radius + dimensions.axisLineExtend)
  }

  /*
   * Sending exiting nodes to the top
   */
  exitTransform (selection) {
    let self = this
    selection.tween('rotate', function (d) {
      let angle = self.scaler(d.id)
        , prevAngle = self.previousScaler(d.id) * 180 / Math.PI

      if (typeof angle === 'number') {
        angle = angle * 180 / Math.PI
      } else {
        // No longer part of the new domain, see which direction we should slide
        // the exiting tick
        let domain0 = self.previousScaler.domain()
          , domain1 = self.scaler.domain()
          , idx = domain0.indexOf(d.id)
          , prevStart = domain0.indexOf(domain1[0])
          , prevEnd = domain0.indexOf(domain1[domain1.length - 1])

        if (idx < prevStart) {
          // Rotate counter clockwise towards the new last tick mark
          angle = (self.scaler(domain1[domain1.length - 1]) * 180 / Math.PI) - 360
        } else if (idx > prevEnd) {
          // Rotate clockwise to the new first point
          angle = 360 - (self.scaler(domain1[0]) * 180 / Math.PI)
        }
      }

      let interpolater = interpolate(prevAngle, angle)

      return t => {
        let _angle = interpolater(t)
        d3.select(this)
          .attr('transform', `rotate(${_angle})`)
          .selectAll('.text-group')
          .attr('transform', function () {
            return `rotate(${-_angle + 90} ${self.radius + dimensions.labelDistance} 0) translate(${self.radius + dimensions.labelDistance}, 0)`
          })
      }
    })
  }

  /*
   * Aligns the ticks in their correct location
   */
  tickTransform (selection) {
    if (!selection.size()) {
      return
    }

    let self = this

    d3.select(selection.node().parentNode)
      .classed('axis-rotated-labels', false) // In case there was a transition from rotated labels

    if (selection.duration) {
      // Get the tick direction
      selection.tween('rotate', function (d) {
        let angle = self.previousScaler(d.id)

        if (typeof angle === 'number') {
          angle = angle * 180 / Math.PI // conver to degrees
        } else {
          // New tick
          angle = this._angle // use the angle set when it entered
        }

        let interpolater = interpolate(angle, self.scaler(d.id) * 180 / Math.PI)
        return t => {
          let _angle = interpolater(t)
          d3.select(this)
            .attr('transform', `rotate(${_angle})`)
            .selectAll('.text-group')
            .attr('transform', function () {
              return `rotate(${-_angle + 90} ${self.radius + dimensions.labelDistance} 0) translate(${self.radius + dimensions.labelDistance}, 0)`
            })
        }
      })
      .select('line')
      .attr('x2', this.radius + dimensions.axisLineExtend)
    } else {
      selection.attr('transform', d => {
               return `rotate(${this.scaler(d.id) * 180 / Math.PI})`
             })
             .select('line')
             .attr('x2', this.radius + dimensions.axisLineExtend)

      selection.selectAll('.text-group')
               .attr('transform', (d) => {
                let angle = self.scaler(d.id) * 180 / Math.PI
                return `rotate(${-angle + 90} ${self.radius + dimensions.labelDistance} 0) translate(${self.radius + dimensions.labelDistance}, 0)`
               })
               .selectAll('.subtitle')
                    .attr('x', 0)
                    .attr('y', dimensions.xAxisTitleHeight)
    }
  }

}

export default PolarLayout

export { dimensions } // TODO probably not ideal
